import { FontIcons } from '@brandfolder/react';
import React, { FunctionComponent, useState } from 'react';

import { PrimaryButton, TextButton } from '@components/library/button';
import CreateSFtpIngestForm from '@components/bulk_management/sftp-ingest/CreateSftpIngestForm';
import { SftpIngestTable } from '@components/bulk_management/sftp-ingest/SftpIngestTable';

const SftpIngestFormContainer: FunctionComponent<{ setShowForm: SetStateDispatch<boolean> }> = ({
  setShowForm
}) => (
  <div id="manage-sftp-ingest">
    <TextButton
      className="sftp-ingests--cancel-edit"
      icon={FontIcons.ArrowLeft}
      onClick={(): void => setShowForm(false)}
    >
      {bfTranslate('Back')}
    </TextButton>
    <CreateSFtpIngestForm
      setShowForm={setShowForm}
    />
  </div>
);

export const SftpIngestManagement: FunctionComponent = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="manage-ftp-ingests">
      <div className="header">
        <h2>{bfTranslate('SFTP Ingest')}</h2>
        {!showForm && (
          <PrimaryButton
            className="ftp-ingest-create-button"
            icon={FontIcons.Plus}
            onClick={(): void => setShowForm(true)}
          >
            {bfTranslate('Create new SFTP ingest')}
          </PrimaryButton>
        )}
      </div>
      <hr />
      {showForm ? (
        <SftpIngestFormContainer
          setShowForm={setShowForm}
        />
      ) : (
        <SftpIngestTable
          setShowForm={setShowForm}
        />
      )}
    </div>
  );
};